module.exports = __webpack_public_path__ + "static/media/gb14.8b63bf65.png";